module.exports = __webpack_public_path__ + "img/share-icon.ab073468.svg";